export interface LogError {
  type: string;
  date: Date;
  data: Error[];
}

export class Log {
  static readonly WARNING = 'Warning';
  static readonly ERROR = 'Error';

  static readonly errors: Array<LogError> = [];

  static errorLogger?: CallableFunction;

  static readonly warn = (...errorData: Error[]) => {
    Log.log(Log.WARNING, errorData);
  };

  static readonly error = (...errorData: Error[]) => {
    Log.log(Log.ERROR, errorData);
  };


private static log(type: string, errorData: Error[]) {
  console.error(type + ':', ...errorData);

  if (typeof window !== 'undefined') {
    if (Log.errorLogger) {
      Log.errorLogger({ type, date: new Date(), data: errorData });
    } else {
      Log.errors.push({ type, date: new Date(), data: errorData });
    }
  }
}


  static readonly setErrorLogger = (errorLogger: CallableFunction) => {
    Log.errorLogger = errorLogger;
  };

  static readonly hasErrors = () => {
    return !!Log.errors.length;
  };

  static readonly getErrors = () => {
    return Log.errors.sort((a, b) => a.date.getTime() - b.date.getTime());
  };
}
